// Versão atual dos Termos de Uso + Política de Privacidade.
// Bumpa SEMPRE que mexer em algo relevante em src/pages/Legal/Terms.jsx
// ou Privacy.jsx. O cadastro registra essa versão no momento do aceite,
// permitindo provar QUE versão o casal aceitou.
//
// Formato ISO (YYYY-MM-DD) — fácil de comparar e ler.
export const CURRENT_TERMS_VERSION = '2026-08-25';
